module.exports = __webpack_public_path__ + "img/2.1496f730.jpg";